// extracted by mini-css-extract-plugin
export var root = "_4pGT";
export var rootContainer = "_5u62";
export var rootDescription = "CVsj";
export var rootHeading = "DQEc";
export var rootImage = "cayh";
export var rootPicture = "_8aQw";